import { createContext, useContext } from 'react';

import type { DealBookingType } from '@src/types/OTC';
import type { DealProductBuilderRow } from '@src/types/OTC/otcProductBuilderTypes';
import type { DealProductBuilderAction, DealProductBuilderActionCreators } from '../dealProductBuilderSlice';

export interface DealProductBuilderContextValue {
  bookingType: DealBookingType;
  setBookingType: (bookingType: DealBookingType) => void;
  state: {
    rowData: DealProductBuilderRow[];
    isFormValid: boolean;
    error: string | null;
    validationErrors: Record<string, string> | null;
  };
  dispatch: React.Dispatch<DealProductBuilderAction>;
  actions: DealProductBuilderActionCreators;
}

export const DealProductBuilderContext = createContext<DealProductBuilderContextValue | undefined>(undefined);

export const useDealProductBuilder = () => {
  const context = useContext(DealProductBuilderContext);
  if (!context) {
    throw new Error('useDealProductBuilder must be used within a DealProductBuilderProvider');
  }
  return context;
};
